import { render, staticRenderFns } from "./competitionPkSetList.vue?vue&type=template&id=1ae9dc2e&scoped=true"
import script from "./competitionPkSetList.vue?vue&type=script&lang=ts"
export * from "./competitionPkSetList.vue?vue&type=script&lang=ts"
import style0 from "./competitionPkSetList.vue?vue&type=style&index=0&id=1ae9dc2e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9dc2e",
  null
  
)

export default component.exports